<template>
  <div class="footter">
    <div class="foot-l">
      <div class="nav-title">
        <span>网站首页</span>|
        <span>关于我们</span>|
        <span>成功案例</span>|
        <span>新闻资讯</span>|
        <span>联系我们</span>
      </div>
      <div class="company-info">
        <p>万博云信（北京）教育科技有限公司</p>
        <p>Copyright © 2015-2016 Vanber. All Rights Reserved. 京ICP备15033449号-2</p>
        <p>院校咨询：189 1165 6408 渠道合作：135 2057 3697</p>
        <p>邮箱：xixun@vanber.cn</p>
        <p><img style="vertical-align: bottom;margin-right: 8px;" src='../assets/image/d361880e8f7a87313125410cb967a90.png' />京公网安备11010802031338号</p>
      </div>
    </div>
    <div class="foot-r">
      <el-image style="width:100px;"  :src="require('../assets/image/wxgzh.jpg')"  :preview-src-list="[require('../assets/image/wxgzh.jpg')]">
      </el-image>
      <!-- <img src="../assets/image/wxgzh.jpg" /> -->
      <p>扫一扫，关注万博云信公众号，了解更多</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footter',
  data() {
    return {
      proList: [],
      srcList:['../assets/image/wxgzh.jpg'],
      url:"../assets/image/wxgzh.jpg",
    };
  },
  components: {},
  created() {},
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
  },
  computed: {
    isToken() {
      return this.$store.state.token;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  methods: {
    handLoginClick() {
      this.$router.push({
        path: '/login',
      });
    },
    handleCommand(com) {
      if (com == 'logOut') {
        this.handleBack();
      }
    },
    handleBack() {
      this.$store.commit('setUserInfo', null);
      this.$store.commit('setToken', null);
    },
  },
};
</script>
<style lang="less" scoped>
.footter {
  background: #282828;
  width: 100%;
  height: 160px;
  text-align: center;
  padding-top: 36px;
  display: flex;
  min-width: 1200px;
  justify-content: center;
  .foot-l {
    .nav-title {
      color: #737272;
      font-size: 14px;
      margin-top: 12px;
      span {
        color: #d9d9d9;
        margin: 0 24px;
      }
    }
    .company-info {
      color: #666666;
      font-size: 14px;
      margin-top: 12px;
    }
  }
  .foot-r {
    padding-top: 24px;
    img {
      width: 100px;
    }
    p {
      font-size: 12px;
      color: #d9d9d9;
    }
  }
}
</style>
